const BASE_PATH = process.env.REACT_APP_BASE_URL;

export default BASE_PATH;
